<template>
    <div class="row justify-content-center m-0">
        <div class="col-md-12 p-0" v-on:click="jobOfferClick()">
            <div :class="'job-offer p-3 ' + type">
                <div :class="'offer-type ' + type">{{ $t(type.capitalize()) }}</div>
                <div class="row align-items-center">
                    <div class="col-md-1 pr-0">
                        <img alt="logo" v-if="company_logo && isAdminCompany" class="img img-fluid"
                             :src="'/storage/admin_company_avatars/' + company_logo"/>
                        <img alt="logo" v-if="company_logo && !isAdminCompany" class="img img-fluid"
                             :src="'/storage/avatars/' + company_logo"/>
                        <span v-if="!company_logo"><i class="fa fa-info-circle fa-5x no-logo"></i></span>
                    </div>
                    <div class="d-inline-block col-md-11 job-offer-details">
                        <div class="float-right"><span
                            class="badge badge-info">{{ $t('Added:') }} {{ created_at }}</span></div>
                        <div class="job-offer-title justify-content-start">{{ title }}</div>
                        <div class="justify-content-start font-italic">{{ $t('Posted by') }}: {{ company_name }}</div>
                        <hr style="border-top: 1px solid #005A93"/>
                        <div class="job-offer-details pb-2 pt-2">

                            <div class="job-offer-badge col-sm-12"
                                 v-html="locationToImage(original_location) + '&nbsp;' + location"></div>
                            <div class="job-offer-badge col-sm-12"><span
                                v-html="this.sectors_images[sector] + '&nbsp;' + $t(sector)"></span></div>
                            <div class="job-offer-badge col-sm-12" v-if="contract_type && contract_type.length > 0"><i
                                class="far fa-file-alt fa-fw"></i>&nbsp;{{ $t(contract_type) }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isAdminCompany', 'offer_id', 'expire_date', 'title', 'location', 'original_location', 'sector', 'contract_type', 'type', 'company_name', 'company_logo', 'created_at'],
    data() {
        return {
            sectors_images: {
                'Aquaculture': '<img class="sector-thumbnail" src="/assets/wheel/small/01.png" />',
                'Coastal tourism': '<img class="sector-thumbnail" src="/assets/wheel/small/02.png" />',
                'Fisheries': '<img class="sector-thumbnail" src="/assets/wheel/small/03.png" />',
                'Marine biotechnology': '<img class="sector-thumbnail" src="/assets/wheel/small/04.png" />',
                'Maritime transport': '<img class="sector-thumbnail" src="/assets/wheel/small/05.png" />',
                'Ocean energy': '<img class="sector-thumbnail" src="/assets/wheel/small/06.png" />',
                'Shipbuilding and maintenance': '<img class="sector-thumbnail" src="/assets/wheel/small/07.png" />',
                'Other': '<i class="fas fa-vector-square fa-fw"></i>'
            }
        }
    },
    methods: {
        jobOfferClick() {
            window.location.href = '/offer/show/' + this.type + '/' + this.offer_id;
        },
        locationToImage(original_location) {
            if (original_location === 'OTHER') {
                return '<i class="far fa-compass fa-fw"></i>';
            } else {
                return '<img alt="' + original_location.toLowerCase() + '" src="/assets/images/flags/' + original_location.toLowerCase() + '.svg" width="28">';
            }

        }
    },
    mounted() {
    }
}
</script>
